import { all, compose, equals, isEmpty, not, prop, propOr } from 'ramda';
import { isNilOrEmpty, isNilOrEmptyString } from 'ramda-extension';
import { createSelector } from 'reselect';

import { codelists } from 'constants/codelists';
import { EMPTY_VALUES, USER_ROLES } from 'constants/general';
import user from 'features/views/user';
import { findById, getCodelistByName, getCodelistPropById } from 'utils';

import { NAME } from './constants';

const getRoot = prop(NAME);

export const getTasks = createSelector(
	getRoot,
	getCodelistByName(codelists.taskTypes),
	(taskSearch, taskTypesCodelist) => {
		const tasks = propOr(EMPTY_VALUES.ARRAY, 'tasks')(taskSearch);

		if (isNilOrEmpty(tasks)) {
			return tasks;
		} else {
			return tasks.map((task) => ({
				...task,
				informative: getCodelistPropById(task?.taskTypeId, taskTypesCodelist, 'informative'),
			}));
		}
	},
);

export const getSort = createSelector(getRoot, propOr('createDate,desc', 'sort'));
export const getSelectedTaskIds = createSelector(getRoot, propOr(EMPTY_VALUES.ARRAY, 'selected'));
export const getHasSelectedTasks = createSelector(getSelectedTaskIds, compose(not, isEmpty));

export const getLastSubmittedFormData = createSelector(getRoot, propOr(EMPTY_VALUES.OBJECT, 'lastSubmittedFormData'));

export const getSelectedTasks = createSelector(getSelectedTaskIds, getTasks, (selectedIds, tasks) =>
	selectedIds.map(findById(tasks)),
);

export const getSelectedTasksAreInformationOnly = createSelector(getSelectedTasks, (selectedTasks) => {
	const selectedTasksInformativeValue = selectedTasks.map((task) => task?.informative);
	return all(equals(1))(selectedTasksInformativeValue);
});

export const getHideStatisticsButton = createSelector(
	user.selectors.getCurrentRole,
	(role) => isNilOrEmptyString(role) || role === USER_ROLES.PPZ || role === USER_ROLES.GUARANTOR,
);
